
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ExerciseCreator",
      function () {
        return require("private-next-pages/ExerciseCreator.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ExerciseCreator"])
      });
    }
  